<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Database Management</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Database Management</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>Database Management Systems</h3>
                    <p>DBMSs optimize data organization using a database schema technique called normalization. As a
                        result, large data tables
                        are split into smaller parts to minimize redundancies and dependencies.

                        DBMSs also support concurrent access which allows multiple users to interact with a database at
                        the same time while
                        maintaining data integrity.
                    </p>

                    <p>DBMSs work using system commands. By inputting a command, the database administrator gives
                        instructions to retrieve,
                        modify, or load existing data.

                        DBMSs usually consist of several integrated components that carry out data management tasks:

                        Storage engine. It is the core element of a DBMS that interacts with the file system at the
                        operating system level.
                        Query language. Examples include the Structured Query Language (SQL) and the MongoDB Query
                        Language (MQL), both used to
                        interact with databases.
                        Query processor. It interprets user queries and makes the commands understandable to the
                        database.
                        Optimization engine. It provides insights for database performance and queries.
                        Metadata catalog. It acts as a repository for database objects. Every time an object is created,
                        it is registered here.
                        The catalog is used to verify user requests and provide details on the database structure.
                        Log manager. This component tracks user activity, logins, backups, and other actions performed
                        with the DBMS.
                        Reporting and monitoring tools. These utilities generate reports and monitor the DBMS’s resource
                        usage.
                        Data utilities. Additional tools that perform backup and recovery tasks, data validation,
                        database repair, and data
                        integrity checks on your shared or private server.</p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Relational Database Management System (RDBMS)
                                    </li>
                                    <li><i class="flaticon-check"></i> Document Database Management System (DoDBMS)</li>
                                    <li><i class="flaticon-check"></i> Columnar Database Management System (CDBMS)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">MSSQL</a></li>
                        <li><a routerLink="/technology-expertise">MySQL</a></li>
                        <li><a routerLink="/technology-expertise">MongoDB</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/reporting-services">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/reporting-services">Reporting Services</a>
                        </h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/powerbi-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/powerbi-services">PowerBI</a>
                        </h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->